module.exports = __webpack_public_path__ + "files/46096fe0f9405e03320adf38c76b9f82.svg";